module.exports = __webpack_public_path__ + "static/media/siddharth-amaravati-trip-banner.1e8894a4.jpg";